import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function CivilLitigation() {
  return (
      <motion.div
      className="max-w-4xl mx-auto px-6 py-12 text-center"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
   
      <h1 className="text-3xl md:text-4xl font-bold mb-6">Civil Litigation </h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-8 text-left">
    Involved in a dispute and seeking legal guidance? We’ve got you covered. Whether you are facing a landlord tenant dispute, contract dispute, debt claim or any other civil matter, it can become challenging to ascertain the options available to you.
We help individuals and businesses assess their legal position, protect their rights and pursue fair resolution of the dispute through negotiations, mediation, or court proceedings.
We are just one email away from recommending strategic advice to enable you resolve the dispute.

      </p>
<Link
        to="/contact"
        className="inline-block px-6 py-3 rounded-lg bg-blue-900 text-white font-semibold shadow hover:bg-blue-800 transition"
      >
        Request Consultation
      </Link>

   
    </motion.div>
  );
}
